import { render, staticRenderFns } from "./VesselTracker.vue?vue&type=template&id=229e7316&scoped=true"
import script from "./VesselTracker.vue?vue&type=script&lang=js"
export * from "./VesselTracker.vue?vue&type=script&lang=js"
import style0 from "./VesselTracker.vue?vue&type=style&index=0&id=229e7316&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "229e7316",
  null
  
)

export default component.exports